export default {
    press (state) {
      return state.press
    },

    selectedPress (state) {
        return state.selectedPress
    },

    getPress: state => (pressRoomContentId) => {
      return state.press().find(press => press.pressRoomContentId === pressRoomContentId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/press/getters.js